import {
  AppBar,
  Box,
  Typography,
  IconButton,
  Toolbar,
  Avatar,
} from "@mui/material";
import { Menu } from "@mui/icons-material";
import React from "react";
import { useSelector } from "react-redux";
import { themePalette } from "../../../constants/Theme/colors";
import { useNavigate } from "react-router-dom";

const Topbar = ({ isMobile, setIsMobile }) => {
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setIsMobile(!isMobile);
  };

  const userInfo = useSelector(state => state?.auth?.userData);
  const name = userInfo?.[0]?.["fullName"];
  const userId = userInfo?.[0]?.["_id"];
  const firstLetters = name
    .split(" ")
    .map(word => word[0])
    .join("");

  const handleProfileClick = () => {
    navigate("/admin/users/profile", { state: { user: userId } });
  };
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { lg: "calc(100% - 238px) !important", xs: "100% !important" },
        ml: { lg: "238px" },
        mt: 0,
        backgroundColor: "background.main",
        color: "text.primary",
        maxHeight: "64px",
        zIndex: 100,
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { lg: "none" } }}
        >
          <Menu />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />

        <Box
          onClick={handleProfileClick}
          sx={{
            flexGrow: 0,
            display: "flex",
            alignItems: "center",
            mr: 2,
            cursor: "pointer",
            borderRadius: "8px",
            px: 1,
            py: 0.5,
            transition: "background-color 0.2s ease",
            "&:hover": {
              backgroundColor: "action.hover",
            },
          }}
        >
          {/*<Box>
            <Tooltip
              title={
                <Typography
                  fontSize={15}
                  fontFamily={"'ArchivoMedium', sans-serif"}
                >
                  Coming Soon
                </Typography>
              }
              arrow
            >
              <NotificationsNoneIcon
                sx={{
                  //color: themePalette.palette.primary.main,
                  color: themePalette.palette.text.secondary,
                  fontSize: 28,
                  mr: 2,
                  display: "inline-block",
                  position: "relative",
                  top: "-10px",
                }}
              />
            </Tooltip>

            <Box
              sx={theme => ({
                display: "inline-block",
                justifyContent: "center",
                alignItems: "center",
                borderRight: `2px solid ${theme.palette.common.headerDivider}`,
                mr: "20px",
                mt: 1,
                height: "45px",
              })}
            ></Box>
          </Box>*/}
          <Avatar
            sx={{
              my: 2,
              width: "38px",
              height: "38px",
              backgroundColor:
                themePalette.palette.common.profileIconBackground,
              color: themePalette.palette.common.profileIconColor,
            }}
          >
            <Typography variant="heading4" sx={{ textTransform: "uppercase" }}>
              {firstLetters}
            </Typography>
          </Avatar>
          <Typography
            variant="heading_regular"
            sx={{ ml: 2, textTransform: "capitalize" }}
          >
            {userInfo[0]["fullName"]}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
